import './modules/navigation.js'
import './modules/timeline.js'
import './modules/blog-posts.js'
import AOS from 'aos'

window.addEventListener('DOMContentLoaded', () => {
	AOS.init({
		duration: 1000,
		once: true,
		offset: 30,
		// disable: () => window.innerWidth < 768,
	})

	setTimeout(() => {
		AOS.refresh()
	}, 100)

	gsap.registerPlugin(ScrollTrigger);
})


